export default __webpack_public_path__ + "static/media/9-Ibrahim-Are you comfortable in your own skin.9c562deb.mp4";